import { ParameterInputType } from "@hex/common";
import { ComponentType } from "react";

import { CustomIconProps } from "../icons/createCustomIcon.js";
import {
  ButtonInputIcon,
  CheckboxInputIcon,
  DropdownInputIcon,
  MultiselectInputIcon,
  NumberIcon,
  NumericInputIcon,
  SliderInputIcon,
  TableCellIcon,
} from "../icons/CustomIcons.js";

/**
 * Lightweight function to get icon component for input parameter types.
 * This file only imports icons (not heavy renderer components) to avoid
 * circular dependencies when used by CellTypeIcon.
 */
export function getInputIconForType(
  inputType?: ParameterInputType,
): ComponentType<CustomIconProps> {
  if (!inputType) {
    return NumberIcon; // fallback to original behavior
  }

  // Direct mapping to avoid circular dependency with input registry
  switch (inputType) {
    case ParameterInputType.BUTTON:
      return ButtonInputIcon;
    case ParameterInputType.SLIDER:
      return SliderInputIcon;
    case ParameterInputType.DROPDOWN:
      return DropdownInputIcon;
    case ParameterInputType.CHECKBOX:
      return CheckboxInputIcon;
    case ParameterInputType.MULTISELECT:
      return MultiselectInputIcon;
    case ParameterInputType.NUMERIC_INPUT:
      return NumericInputIcon;
    case ParameterInputType.TABLE:
      return TableCellIcon;
    case ParameterInputType.TEXT_INPUT:
    case ParameterInputType.DATE:
    case ParameterInputType.FILE_UPLOAD:
    default:
      return NumberIcon; // fallback for other input types
  }
}
